<div class="row">
  <app-clock></app-clock>
</div>
<div class="row">
  <div class="col-12 col-md-5">
    <!-- Vamos a capturar el evento del hijo -->
    <app-formulario (tareaCreada)="onTareaCreada($event)"></app-formulario>
  </div>
  <div class="col-12 col-md-7">
    <app-lista [tareas]="arrTareas"></app-lista>
  </div>
</div>